module.exports = __webpack_public_path__ + "assets/responsiveWebDesign.afe961f5ace07b373340c85ab9de7849.png";


//////////////////
// WEBPACK FOOTER
// ./img/landingPage/responsiveWebDesign.png
// module id = 880
// module chunks = 0